'use strict';

module.exports = function () {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next-util@0.7.0@@alicd/next-util/lib/can-use-dom.js
// module id = 685
// module chunks = 0